import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import Icon from "@/components/icon/Icon.vue";
import { alertError } from "@/util/dialog";
/**
 * DEMO_MODE locked "watch & publish" editor. Confined (non-admin) users cannot edit the AI-generated
 * speach: they watch a progress bar (AI generation + content completeness) and can only publish once
 * the speach is finished. Publishing goes out as SEMI_PRIVE (enforced server-side).
 */
let DemoEditorLock = class DemoEditorLock extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speachTitle", void 0);
    _defineProperty(this, "speachDescription", void 0);
    _defineProperty(this, "thumbnailUrl", void 0);
    _defineProperty(this, "playerUrl", void 0);
    _defineProperty(this, "progressUrl", void 0);
    _defineProperty(this, "publishUrl", void 0);
    _defineProperty(this, "percent", 0);
    _defineProperty(this, "publishable", false);
    _defineProperty(this, "totalSubchapters", 0);
    _defineProperty(this, "validSubchapters", 0);
    // Human-readable message emitted by the generator (same source as the per-chapter progress UI).
    _defineProperty(this, "currentMessage", '');
    _defineProperty(this, "published", false);
    _defineProperty(this, "publishing", false);
    _defineProperty(this, "alreadyPublished", false);
    _defineProperty(this, "pollTimer", null);
  }
  get shareUrl() {
    return this.playerUrl ? window.location.origin + this.playerUrl : '';
  }
  mounted() {
    this.pollProgress();
  }
  beforeUnmount() {
    this.clearTimer();
  }
  clearTimer() {
    if (this.pollTimer !== null) {
      window.clearTimeout(this.pollTimer);
      this.pollTimer = null;
    }
  }
  async pollProgress() {
    try {
      const resp = await axios.get(this.progressUrl);
      const data = resp.data || {};
      this.percent = typeof data.progressPercent === 'number' ? data.progressPercent : this.percent;
      this.publishable = data.publishable === true;
      this.alreadyPublished = data.alreadyPublished === true;
      this.totalSubchapters = data.totalSubchapters || 0;
      this.validSubchapters = data.validSubchapters || 0;
      this.currentMessage = data.currentMessage || '';
    } catch (e) {
      // Generation may still be starting — keep polling.
    }
    // Keep polling until the speach is ready to publish (or already published).
    if (!this.publishable && !this.published && !this.alreadyPublished) {
      this.pollTimer = window.setTimeout(() => this.pollProgress(), 3000);
    }
  }
  play() {
    if (this.playerUrl) {
      window.location.href = this.playerUrl;
    }
  }
  async publish() {
    if (!this.publishable || this.publishing) {
      return;
    }
    this.publishing = true;
    try {
      const resp = await axios.post(this.publishUrl);
      const data = resp.data;
      if (data && data.error) {
        alertError(data.message);
        return;
      }
      this.clearTimer();
      // Published → go straight to the reading (player) interface.
      if (this.playerUrl) {
        window.location.href = this.playerUrl;
        return;
      }
      this.published = true; // fallback (no player URL): show the success screen
    } catch (e) {
      alertError(typeof e === 'string' ? e : e && e.message || 'Error');
    } finally {
      this.publishing = false;
    }
  }
  copyShareUrl() {
    if (this.shareUrl && navigator.clipboard) {
      navigator.clipboard.writeText(this.shareUrl);
    }
  }
  createAnother() {
    window.location.href = '/recorder/aiSpeachGenerator';
  }
};
__decorate([Prop({
  default: ''
})], DemoEditorLock.prototype, "speachTitle", void 0);
__decorate([Prop({
  default: ''
})], DemoEditorLock.prototype, "speachDescription", void 0);
__decorate([Prop({
  default: ''
})], DemoEditorLock.prototype, "thumbnailUrl", void 0);
__decorate([Prop({
  default: ''
})], DemoEditorLock.prototype, "playerUrl", void 0);
__decorate([Prop({
  required: true
})], DemoEditorLock.prototype, "progressUrl", void 0);
__decorate([Prop({
  required: true
})], DemoEditorLock.prototype, "publishUrl", void 0);
DemoEditorLock = __decorate([Component({
  components: {
    Icon
  }
})], DemoEditorLock);
export default DemoEditorLock;